// Same table look as AdminSetupV2's tabs (CategoriesTab.jsx) so Expense
// Management matches the rest of the app rather than default Bootstrap tables.
export const thStyle = {
  background: "#F9FAFB",
  fontWeight: 600,
  fontSize: "13px",
  color: "#374151",
  padding: "12px 16px",
  borderBottom: "1px solid #E5E7EB",
  whiteSpace: "nowrap",
};

export const tdStyle = {
  padding: "12px 16px",
  fontSize: "14px",
  color: "#374151",
  borderBottom: "1px solid #F3F4F6",
  verticalAlign: "middle",
};

export const cardStyle = {
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
  overflow: "hidden",
};

export const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: 600,
  color: "#374151",
  marginBottom: "6px",
};

export const inputStyle = { height: "40px", fontSize: "14px", borderRadius: "6px" };

export const iconBtnStyle = {
  background: "none",
  border: "none",
  padding: "4px",
  cursor: "pointer",
  color: "#C0335A",
  display: "inline-flex",
  alignItems: "center",
};

export const badgeStyle = (bg, color) => ({
  display: "inline-block",
  padding: "3px 10px",
  borderRadius: "12px",
  fontSize: "12px",
  fontWeight: 600,
  background: bg,
  color,
  whiteSpace: "nowrap",
});

export const todayYmd = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

export const SERVICE_FLAGS = [
  ["washing", "Washing"],
  ["polishing", "Polishing"],
  ["pdi", "PDI"],
  ["valeting", "Valeting"],
];

export const describeServices = (entry) =>
  SERVICE_FLAGS.filter(([key]) => Number(entry[key]) === 1)
    .map(([, label]) => label)
    .join(", ") || "—";
